import React, { useEffect, useState } from 'react';
import MobileSubMenu from "../NonDesktopSubmenu";
import { connect } from "react-redux";
import { ReactComponent as CloseIcon } from "../../../../design-system/design_system/assets/icons/components/notifications/close.svg";
import { ReactComponent as PlatinumIcon } from "../../../../design-system/design_system/assets/icons/system/user.svg";
import { setMobileMenuState, setMobileOverlayDisplay } from "../../../actions/HeaderActions";
import { bindActionCreators } from "redux";
import { Link } from 'react-router-dom';
import ReactHtmlParser from 'html-react-parser';
import { formateRCIPoints } from "../../../../utils/dateFormate";
const { REACT_APP_IMAGEURL } =window.weeksWebCloudConfig;

const NonDestopMyAccount = props => {
    const [notification, setNotification] = useState(true);
    const [dismissBannerFlag, setDismissBannerFlag] = useState(sessionStorage.getItem("DISMISS_ARPBANNER") ? true : false);
    const { showMobileSubMenu, showMobileOverlay,
        closeMobileMenuConatiner, myAccountInfoData,
        setMobileMenuStateFunc, deviceWidth, notificationData,
        MobileMenuState, arpBannerData, customerId,
        customerPoints, customerLocal, setMobileOverlayDisplayFunc, customerProfile } = props;
    //console.log(props);

    //debugger;
    const arpButtonData = arpBannerData.ArpContainer !== undefined ? arpBannerData.ArpContainer : null;
    const promoBannerInfo = arpBannerData.PromoInfo ? arpBannerData.PromoInfo : "";
    const arpLinks = myAccountInfoData.MyAccountLinks.Link !== undefined ? myAccountInfoData.MyAccountLinks : null;
    const handleNotification = () => {
        setNotification(true);
        setMobileMenuStateFunc("NOTIFICATION");
    }

    const signOut = (e, urlLink) => {
        e.stopPropagation();
        sessionStorage.removeItem("URL_RESOLVER_TOKEN");
        sessionStorage.removeItem("NOTIFICATION_FLAG");
        sessionStorage.removeItem("DISMISS_ARPBANNER");
        window.location.href = urlLink;
    }

    

    const myAccountClassDesktop = () => {

        if (promoBannerInfo === "" || dismissBannerFlag) {
            return "myAccount-container no-banner  bg-white"
        }
        else {
            return "myAccount-container bg-white"
        }

    }

    useEffect(() => {
    }, [dismissBannerFlag, deviceWidth])

    const dismissArpBanner = (e) => {
        e.stopPropagation();
        setDismissBannerFlag(true);
        sessionStorage.setItem("DISMISS_ARPBANNER", true);
    }


    const tradingPowerBalance = () => {
        let tradingcount = 0
        if (customerPoints !== null && customerPoints.length > 0) {
            customerPoints.map(TPBlnc => {
                if (TPBlnc.tradingPower !== undefined) tradingcount = tradingcount + TPBlnc.tradingPower;
            })
        }
        return tradingcount;
    }

    const RenewOrPlatinumRenewLink = () =>{
        if(customerProfile.eligibleFeatures.eligibleForRenewal){
            return(
                <li data-testid={myAccountInfoData.MyAccountLinks.RenewLink.HoverText}><a href={myAccountInfoData.MyAccountLinks.RenewLink.URL} className="px-4 py-2"
                aria-label={myAccountInfoData.MyAccountLinks.RenewLink.HoverText}>
                <img src={REACT_APP_IMAGEURL + myAccountInfoData.MyAccountLinks.RenewLink.LinkIcon}
                    alt={myAccountInfoData.MyAccountLinks.RenewLink.HoverText} className="pr-2" />
                <span>{myAccountInfoData.MyAccountLinks.RenewLink.DisplayText}</span></a>
                </li>
            )
          
        }
        else if(arpButtonData !== null 
            && 
            customerProfile.eligibleFeatures.eligibleForARPRenewal !== undefined
            && 
            customerProfile.eligibleFeatures.eligibleForARPRenewal
            ){
             return(
                <li data-testid={arpButtonData.DisplayText}>
                <a href={arpButtonData.URL} className="px-4 py-2"
                aria-label={arpButtonData.HoverText}>
                <img src={REACT_APP_IMAGEURL + arpButtonData.LinkIcon}
                    alt={arpButtonData.HoverText} className="pr-2" />
                <span>{arpButtonData.DisplayText}</span></a>
            </li>
             )   
           
        }
        else return false;
           
           
        
    }

    return (
        <>

            <div className={myAccountClassDesktop()}>

                <div className="row m-0">
                    {deviceWidth < 375 &&
                        <CloseIconContainer
                            closeMobileMenuConatiner={closeMobileMenuConatiner}
                        />
                    }
                    {(MobileMenuState === "ALL" && promoBannerInfo !== "" && !dismissBannerFlag) &&
                        promoBannerInfo !== undefined &&
                        <ArpBannerContainer
                            imageUrl={REACT_APP_IMAGEURL}
                            promoBannerData={promoBannerInfo}
                            device={deviceWidth}
                            dismissArpBannerFunc={dismissArpBanner}
                        />}
                    <div className={`${promoBannerInfo !== "" && !dismissBannerFlag ? "col-lg-5" : "col-lg-12"} p-0`}>
                        <div className={`row py-3 m-0 px-2 border-bottom ${customerProfile.enrolledARPName === "Platinum" ? "bg-gray-700 text-uppercase" : ""}`}>
                            <div className="col-4">
                                {
                                    customerProfile.enrolledARPName === "Platinum"
                                        ?
                                        <PlatinumIcon className='svg-fill-disabled' width="100%" height="100%" />
                                        :
                                        <img src={REACT_APP_IMAGEURL + "/static/images/content/icons-header/member-id.svg"} alt={myAccountInfoData.IconAltText} />
                                }
                            </div>
                            <div className="col-8 pt-2">
                                {
                                    customerProfile.enrolledARPName === "Platinum"
                                        ?
                                        <p className="mb-0 font-weight-bolder text-white">{arpButtonData !== null && arpButtonData.ARPIndicatorText} {myAccountInfoData.MemberIdLabelText} {customerId}</p>
                                        :
                                        <>
                                            <p className="mb-0 font-weight-bolder">{myAccountInfoData.MemberIdLabelText}</p>
                                            <p>{customerId}</p>
                                        </>
                                }
                            </div>

                            {
                                customerProfile.enrolledARPName !== "Platinum" && arpButtonData !== null ?
                                    <div className="col-12 mt-3">
                                        <div className={`${arpButtonData.StyleSelector ? arpButtonData.StyleSelector : "bg-priority"} text-uppercase text-center rounded p-1 font-weight-bolder`}>
                                            {arpButtonData.ARPIndicatorText}
                                        </div>
                                    </div>
                                    :
                                    customerProfile.membershipType === "EPIC" &&
                                    <div className="col-12 mt-3">
                                        <div className="bg-priority text-uppercase text-center rounded p-1 font-weight-bolder">
                                            {promoBannerInfo.TitleText}
                                        </div>
                                    </div>
                            }


                        </div>

                        <div className="row p-3 m-0 border-bottom">
                            <div className="col-12">
                                <div className="profile-section-menu profile-section-menu-deposit border-bottom-responsive">
                                    <div className='font-weight-bolder'>{tradingPowerBalance()} {myAccountInfoData.WeeksInfo.TRPText}</div>
                                    <a data-testid="Manage_My_Deposit_Link" href={myAccountInfoData.WeeksInfo.ManageDepositButton.URL}>{myAccountInfoData.WeeksInfo.ManageDepositButton.DisplayText}</a>
                                </div>

                            </div>
                        </div>

                        <div className="d-lg-none">
                            <MobileSubMenu
                                deviceWidth={deviceWidth}
                                showMobileOverlay={showMobileOverlay}
                                slideNotification={notification}
                            />

                        </div>


                        <div className="row m-0 py-3 my-account-link-container border-bottom">
                            <ul className="m-0 col-12">
                                
                                {myAccountInfoData.MyAccountLinks.MyAccountLink !== undefined &&
                                    <li data-testid={myAccountInfoData.MyAccountLinks.MyAccountLink.HoverText}><a href={myAccountInfoData.MyAccountLinks.MyAccountLink.URL} className="px-4 py-2" aria-label={myAccountInfoData.MyAccountLinks.MyAccountLink.HoverText}>
                                        <img src={REACT_APP_IMAGEURL + "/static/images/content/icons-header/my-account-mobile.svg"}
                                            alt={myAccountInfoData.MyAccountLinks.MyAccountLink.HoverText} className="pr-2" />
                                        <span>{myAccountInfoData.MyAccountLinks.MyAccountLink.DisplayText}</span></a>
                                    </li>
                                }


                                {deviceWidth < 812 &&
                                    <li data-testid={myAccountInfoData.MyAccountLinks.NotificationsLink.HoverText}><a href="#!" className="px-4 py-2" onClick={handleNotification}
                                        aria-label={myAccountInfoData.MyAccountLinks.NotificationsLink.HoverText}>
                                        <img src={REACT_APP_IMAGEURL + myAccountInfoData.MyAccountLinks.NotificationsLink.LinkIcon}
                                            alt={myAccountInfoData.MyAccountLinks.NotificationsLink.HoverText} className="pr-2" />
                                        <span>{myAccountInfoData.MyAccountLinks.NotificationsLink.DisplayText}</span>
                                        {notificationData.Alert !== undefined &&
                                            <span className="rounded-circle bg-watermelon alert-count float-right">{notificationData.Alert.length}
                                        </span>
                                        }
                                    </a>
                                    </li>}
                                        <RenewOrPlatinumRenewLink/>

                                {myAccountInfoData.MyAccountLinks.FavoritesLink !== undefined &&
                                    <li onClick={closeMobileMenuConatiner} data-testid={myAccountInfoData.MyAccountLinks.FavoritesLink.HoverText}>
                                        <a href={myAccountInfoData.MyAccountLinks.FavoritesLink.URL} aria-label={myAccountInfoData.MyAccountLinks.FavoritesLink.HoverText} className="px-4 py-2">
                                            <img src={REACT_APP_IMAGEURL + myAccountInfoData.MyAccountLinks.FavoritesLink.LinkIcon}
                                                alt={myAccountInfoData.MyAccountLinks.FavoritesLink.HoverText} className="pr-2" />
                                            <span>{myAccountInfoData.MyAccountLinks.FavoritesLink.DisplayText}</span></a>
                                    </li>
                                }

                                <MyAccountInfoDynamicLink
                                    arpLinkData={arpLinks}
                                />
                                <MyAccountDynamicLink
                                    myAccountInfoLink={arpBannerData.Link}
                                />

                            </ul>
                        </div>

                        <div className="row m-0 my-account-link-container">
                            <ul className="m-0 col-12">
                                <li data-testid={myAccountInfoData.MyAccountLinks.SignoutLink.HoverText}>
                                    <a href="#" onClick={(e) => signOut(e, myAccountInfoData.MyAccountLinks.SignoutLink.URL)}
                                        aria-label={myAccountInfoData.MyAccountLinks.SignoutLink.HoverText}
                                        className="px-4 py-3">
                                        <img src={REACT_APP_IMAGEURL + myAccountInfoData.MyAccountLinks.SignoutLink.LinkIcon}
                                            className="pr-2"
                                            alt={myAccountInfoData.MyAccountLinks.SignoutLink.HoverText}
                                        />
                                        <span>{myAccountInfoData.MyAccountLinks.SignoutLink.DisplayText}</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

            </div>

        </>


    )
}
const mapStateToProps = state => ({
    myAccountInfoData: state.CommonReducer.myAccountInfo,
    notificationData: state.CommonReducer.notification,
    MobileMenuState: state.CommonReducer.menuState,
    UrlToken: state.CommonReducer.urlResolverToken,
    customerId: state.CommonReducer.customerId,
    customerPoints: state.CommonReducer.pointsBalance,
    customerLocal: state.CommonReducer.locale,
    customerProfile: state.CommonReducer.customerProfile
})
const mapDispatchToProps = (dispatch) => bindActionCreators({
    setMobileMenuStateFunc: setMobileMenuState,
    setMobileOverlayDisplayFunc: setMobileOverlayDisplay
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(NonDestopMyAccount);

const CloseIconContainer = ({ closeMobileMenuConatiner }) => {
    return (
        <div className="bg-dark col-12 py-3 border-bottom">
            <div className="col-2 offset-10">
                <button type="button" aria-label="Close" onClick={closeMobileMenuConatiner}>
                    <CloseIcon width="24px" height="24px" />
                </button>
            </div>
        </div>
    )

}

const ArpBannerContainer = ({ imageUrl, promoBannerData, device, dismissArpBannerFunc }) => {

    return (
        <div className="col-lg-7 arpBannerContainer">
            <div className="row m-0 position-relative">
                <div className="col-2 col-lg-6 mx-auto">
                    <img src={imageUrl + promoBannerData.ImagePath}
                        alt={promoBannerData.AltText}
                        className="w-100" />
                </div>
                <div className="col-10 col-lg-12">
                    <h3 className="profile-membership">{promoBannerData.TitleText}</h3>
                    <div className="profile-membership-detail"></div>
                    {ReactHtmlParser(promoBannerData.Description)}
                    {
                        promoBannerData.PromoCTAButton !== undefined &&
                        <a aria-label={promoBannerData.PromoCTAButton.HoverText}
                            href={promoBannerData.PromoCTAButton.URL}
                            className={`${promoBannerData.PromoCTAButton.StyleSelector}
                        btn btn-priority d-none d-lg-block my-3`}
                            target={promoBannerData.ExternalIndicator === 2 ? "_blank" : "_self"}
                            rel="noreferrer"
                            role="button">
                            {promoBannerData.PromoCTAButton.DisplayText}</a>
                    }

                    {
                        promoBannerData.DismissCTAButton !== undefined &&
                        <a
                            href="#!"
                            aria-label={promoBannerData.DismissCTAButton.HoverText}
                            className={`${promoBannerData.DismissCTAButton.StyleSelector} dismiss-btn d-none d-lg-block`}
                            role="button"
                            onClick={dismissArpBannerFunc}
                        >
                            {promoBannerData.DismissCTAButton.DisplayText}</a>
                    }

                </div>
                <a href={promoBannerData.PromoUrl} aria-label="Upgrade Now" className="position-absolute d-lg-none h-100 w-100">
                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+M9QDwADhgGAWjR9awAAAABJRU5ErkJggg==" alt="error img" />
                </a>
            </div>
        </div>

    )

}

const MyAccountInfoDynamicLink = ({ arpLinkData }) => {
    if (arpLinkData !== null) {
        if (arpLinkData.Link.length > 0) {
            return (
                arpLinkData.Link.map((linksData, indexkey) => {
                    return (
                        <li data-testid={linksData.HoverText} key={indexkey}>
                            <a href={linksData.URL} className="px-4 py-2"
                                aria-label={linksData.HoverText}>
                                <img src={REACT_APP_IMAGEURL + linksData.LinkIcon} className="pr-2" alt={linksData.HoverText} />
                                <span>{linksData.DisplayText}</span></a></li>
                    )
                })
            )
        }
        else {
            return (
                <li data-testid={arpLinkData.Link.HoverText}><a href={arpLinkData.Link.URL} className="px-4 py-2"
                    aria-label={arpLinkData.Link.HoverText}>
                    <img src={REACT_APP_IMAGEURL + arpLinkData.Link.LinkIcon} className="pr-2"
                        alt={arpLinkData.Link.HoverText}
                    />
                    <span>{arpLinkData.Link.DisplayText}</span></a>
                </li>
            )

        }
    }
    else return false;
}


const MyAccountDynamicLink = ({ myAccountInfoLink }) => {
    if (myAccountInfoLink !== undefined) {
        if (myAccountInfoLink.length > 0) {
            return (
                myAccountInfoLink.map((linksData, IndexKey) => {
                    return (
                        <li data-testid={linksData.HoverText} key={IndexKey}>
                            <a href={linksData.URL}
                                aria-label={linksData.HoverText}
                                className="px-4 py-2">
                                <img src={REACT_APP_IMAGEURL + linksData.LinkIcon} className="pr-2" alt={linksData.HoverText} />
                                <span>{linksData.DisplayText}</span></a></li>
                    )
                })
            )
        }
        else {
            return (
                <li data-testid="myAccountInfo-secondary-link">
                    <a href={myAccountInfoLink.URL}
                        className="px-4 py-2"
                        aria-label={myAccountInfoLink.HoverText}
                        data-testid={myAccountInfoLink.HoverText}
                    >
                        <img src={REACT_APP_IMAGEURL + myAccountInfoLink.LinkIcon} className="pr-2"
                            alt={myAccountInfoLink.HoverText}
                        />
                        <span>{myAccountInfoLink.DisplayText}</span></a>
                </li>
            )
        }

    }
    else return false;
} 
